import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '../Icon/Icon';
import { Text } from '../Text/Text';
import { FlexContainer } from '../layout/FlexContainer';
export const NoData = ({ text, textVariant, iconName = 'SearchOff', noIcon, textFontWeightOverride, gap, horizontalAlign = 'center', }) => {
    return (_jsxs(FlexContainer, { direction: 'column', gap: gap, horizontalAlign: horizontalAlign, verticalAlign: 'center', fullHeight: true, children: [!noIcon && _jsx(Icon, { color: 'greyLight', name: iconName }), _jsx(Text, { variant: textVariant, fontWeightOverride: textFontWeightOverride, children: text })] }));
};
